document.addEventListener('DOMContentLoaded',()=>{
  const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
  const toast=(m)=>{const t=$('#toast');if(!t)return;t.textContent=m;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2200)};
  const nav=$('[data-nav]'),menu=$('[data-menu-toggle]'); if(menu)menu.addEventListener('click',()=>nav.classList.toggle('open'));

  $$('.thumbs button').forEach(b=>b.addEventListener('click',()=>{const i=$('#ProductImage');if(i)i.src=b.dataset.image}));

  const form=$('#AddToCartForm');
  if(form){
    const variantsEl=$('[data-product-variants]'), optionsEl=$('[data-product-options]');
    let variants=[], optionNames=[];
    try{variants=JSON.parse(variantsEl?.textContent||'[]'); optionNames=JSON.parse(optionsEl?.textContent||'[]')}catch(e){}
    const selects=$$('[data-option-index]'), idInput=form.querySelector('[data-variant-id]');
    const priceEl=$('[data-product-price]'), compareEl=$('[data-compare-price]'), titleEl=$('[data-selected-variant-title]'), addBtn=$('[data-add-button]');
    const qtyInput=$('[data-qty-input]');
    const money=(cents)=>new Intl.NumberFormat('en-ZA',{style:'currency',currency:'ZAR',maximumFractionDigits:2}).format((cents||0)/100);
    const currentValues=()=>selects.map(s=>s.value);
    const findVariant=()=>{
      const values=currentValues();
      return variants.find(v=>v.options.every((value,i)=>value===values[i])) || variants.find(v=>v.available) || variants[0];
    };
    const updateAvailability=()=>{
      selects.forEach((select,index)=>{
        [...select.options].forEach(opt=>{
          const test=currentValues(); test[index]=opt.value;
          const exists=variants.some(v=>v.options.every((value,i)=>value===test[i]));
          const inStock=variants.some(v=>v.available&&v.options.every((value,i)=>value===test[i]));
          opt.disabled=!exists;
          opt.textContent=opt.value+(exists&&!inStock?' — Sold out':'');
        });
      });
    };
    const updateVariant=()=>{
      const v=findVariant(); if(!v)return;
      idInput.value=v.id;
      if(priceEl)priceEl.textContent=money(v.price);
      if(compareEl)compareEl.textContent=v.compare_at_price?money(v.compare_at_price):'';
      if(titleEl)titleEl.textContent=v.title;
      if(addBtn){addBtn.disabled=!v.available;addBtn.textContent=v.available?(addBtn.dataset.originalText||'Add to cart'):'Sold out';}
      if(v.featured_image?.src){const image=$('#ProductImage');if(image)image.src=v.featured_image.src;}
      updateAvailability();
    };
    if(addBtn)addBtn.dataset.originalText=addBtn.textContent;
    selects.forEach(s=>s.addEventListener('change',updateVariant));
    updateVariant();
    $('[data-qty-minus]')?.addEventListener('click',()=>qtyInput.value=Math.max(1,(+qtyInput.value||1)-1));
    $('[data-qty-plus]')?.addEventListener('click',()=>qtyInput.value=(+qtyInput.value||1)+1);
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const variant=form.querySelector('[data-variant-id]').value;
      const quantity=Math.max(1,+qtyInput.value||1);
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+variant,quantity}]})});
        if(!res.ok)throw new Error();
        const cart=await fetch('/cart.js').then(r=>r.json());
        const count=$('[data-cart-count]');if(count)count.textContent=cart.item_count;
        toast('Added to your cart ✨');
      }catch(err){toast('Could not add to cart. Please try again.');}
    });
  }

  async function updateLine(line,quantity){try{const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});if(!r.ok)throw new Error();location.reload()}catch(e){toast('Could not update cart.')}}
  $$('[data-cart-remove]').forEach(b=>b.addEventListener('click',()=>updateLine(b.closest('[data-line]').dataset.line,0)));
  $$('[data-cart-minus]').forEach(b=>b.addEventListener('click',()=>{const row=b.closest('[data-line]'),i=row.querySelector('[data-cart-qty]');updateLine(row.dataset.line,Math.max(0,+i.value-1))}));
  $$('[data-cart-plus]').forEach(b=>b.addEventListener('click',()=>{const row=b.closest('[data-line]'),i=row.querySelector('[data-cart-qty]');updateLine(row.dataset.line,+i.value+1)}));
  $$('[data-cart-qty]').forEach(i=>i.addEventListener('change',()=>updateLine(i.closest('[data-line]').dataset.line,Math.max(0,+i.value))));
});
